import React from "react";
import { Input } from "semantic-ui-react";
import { copyToClipboard } from "../../utilities/copyutils";

const EmbedCodeInput = ({ embedCode }: { embedCode: string }) => {
  const [isCopied, setIsCopied] = React.useState(false);

  const onCopy = () => {
    copyToClipboard(embedCode);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 5000);
  }

  return <Input
    action={{
      color: "green",
      icon: isCopied ? "clipboard check" : "copy",
      onClick: (e) => {
        e.preventDefault();
        onCopy();
      },
      title: "Copy"
    }}
    fluid
    value={embedCode}
  />
}

export default EmbedCodeInput;